import { render, staticRenderFns } from "./CustomerDataBankReport.vue?vue&type=template&id=17aa2678"
import script from "./CustomerDataBankReport.vue?vue&type=script&lang=js"
export * from "./CustomerDataBankReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerDataBankReport.vue?vue&type=style&index=0&id=17aa2678&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports